var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.link)?_c('div',[_c('iframe',{staticClass:"youtube-container",attrs:{"id":"player","type":"text/html","width":"100%","height":_vm.height,"src":_vm.src}}),(_vm.link.name)?_c('div',{staticClass:"youtube-name"},[_vm._v(" "+_vm._s(_vm.link.name)+" ")]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }